export const DOMAIN_PILL_RIGHT_MARGIN = 5;
export const DOMAIN_ROW_HEIGHT = 30;
export const MORE_BUTTON_WIDTH = 70;
